import { xjsTemplateService } from './XJStemplate.service';
var xjsTemplate = /** @class */ (function () {
    function xjsTemplate() {
    }
    xjsTemplate.prototype.getTemplate = function () {
        return xjsTemplateService.template;
    };
    xjsTemplate.prototype.bind = function (request) {
        xjsTemplateService.template = request.template;
    };
    return xjsTemplate;
}());
export { xjsTemplate };
//# sourceMappingURL=XJStemplate.js.map